import styled from "styled-components";

export const WrapperLayout = styled.section`
    width: 100%;
    margin: 80px auto;
`

export const WrapperContent = styled.div`
    width: 1010px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
`